import { jsx as _jsx } from "react/jsx-runtime";
import { Column } from "@faire/web--source/slate/Layout";
import React from "react";
import { SDUIOnClickHandler } from "@faire/retailer/components/SDUI/__internal__/SDUIOnClickHandler/SDUIOnClickHandler";
import { SDUITypographyRenderer } from "@faire/retailer/components/SDUI/ComponentRenderers/Typography/SDUITypographyRenderer";
export var SDUITextTileRenderer = function(param) {
    var tileElement = param.tileElement, loggingData = param.loggingData;
    var on_click = tileElement.on_click, text_tile = tileElement.text_tile;
    var texts = (text_tile !== null && text_tile !== void 0 ? text_tile : {}).texts;
    if (!texts || texts.length === 0) {
        return null;
    }
    return /*#__PURE__*/ _jsx(SDUIOnClickHandler, {
        onClickActions: on_click,
        loggingData: loggingData,
        logLegacyClickEvent: true,
        children: /*#__PURE__*/ _jsx(Column, {
            gap: "1x",
            children: texts.map(function(textElement, i) {
                var _textElement_logging_data;
                return /*#__PURE__*/ _jsx(SDUITypographyRenderer, {
                    textElement: textElement,
                    loggingData: loggingData
                }, "".concat(i, "-").concat((_textElement_logging_data = textElement.logging_data) === null || _textElement_logging_data === void 0 ? void 0 : _textElement_logging_data.instance_identifier));
            })
        })
    });
};
